import { useEffect } from "react";
import { ClipboardCheck } from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";

import { CrmPetDiagnosisController } from "../../../services/controllers/crmPetDiagnosis";
import { useMerchant } from "../../../store/global/useMerchant";
import BasePage from "../../basePage";
import { DiagnosisTabs } from "./components/DiagnosisTabs";

export function CrmPetDiagnosis() {
  const controller = CrmPetDiagnosisController();
  const history = useHistory();
  const location = useLocation();
  const merchant = useMerchant((state) => state.data.merchant);

  useEffect(() => {
    controller.init({ storeId: merchant?.id, search: location.search, history });
  }, [controller, history, location.search, merchant?.id]);

  return (
    <BasePage
      pageTitle={
        <span className="flex items-center gap-2">
          <ClipboardCheck className='w-6 h-6' />
          Diagnóstico CRM Pet
        </span>
      }
    >
      <div className="flex w-full flex-1 flex-col gap-5 pr-4 pb-8">
        <DiagnosisTabs />
      </div>
    </BasePage>
  );
}

export default CrmPetDiagnosis;
